import { render, staticRenderFns } from "./idTag.vue?vue&type=template&id=405ed2b5&"
import script from "./idTag.vue?vue&type=script&lang=js&"
export * from "./idTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports